import { useParams } from "react-router-dom";
import { Terminal } from "../components/atoms";

export default function EnvironmentBuildLogs() {
  let params = useParams();
  return <Terminal url={"/environment/" + params.envId + "/build/logs"} fullscreen snackNotifications />;
}
